import { z } from 'zod'

import ZBaseAction from './base'

export const ZHangupAction = ZBaseAction.extend({
  hangup: z.object({}),
})
